import { API_AUTH } from "./common";

const DongLaiApi = {
  suaTienLai: ({ paidId, valuePaid }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/sua-tien-lan-dong-lai?paidId=${paidId}&valuePaid=${valuePaid}`,
      {}
    ),
  suaTienGoc: ({ paidId, valueGoc }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/sua-tien-goc-lan-dong-lai?paidId=${paidId}&valueGoc=${valueGoc}`,
      {}
    ),
  suaTienGop: ({ paidId, valueGop }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/sua-tien-gop-lan-dong-lai?paidId=${paidId}&valueGop=${valueGop}`,
      {}
    ),
  nhapPhiPhat: ({ paidId, phiPhat }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/nhap-phi-phat-dong-lai?paidId=${paidId}&phiPhat=${phiPhat}`,
      {}
    ),
  chiTietPhiHangKy: (chovayId, paidId, typeChoVay) =>
    API_AUTH.get(
      `quan-ly-cho-vay/chi-tiet-phi-cho-vay-theo-cho-vay?chovayId=${chovayId}&paidId=${paidId}&typeChoVay=${typeChoVay}`,
      {}
    ),
};

export default DongLaiApi;
